<template>
<div id="main-content" class="taskboard">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-lg-6 col-md-8 col-sm-12">
          <h2><a href="javascript:void(0);" class="btn btn-xs btn-link btn-toggle-fullwidth"><i class="fa fa-arrow-left"></i></a> Tickets</h2>
          <ul class="breadcrumb">
            <li class="breadcrumb-item"><a href="index.html"><i class="icon-home"></i></a></li>                            
            <li class="breadcrumb-item">Apps</li>
            <li class="breadcrumb-item active">Tickets</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="header">
            <h2>Report Dashboard</h2>
          </div>
            <div class="body">
              <div class="row">
                <div class="form-group col-2">
                  <label for="module">Type</label>
                  <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="cht.type">
                    <option value="monthly">Monthly</option>
                    <option value="weekly">Weekly</option>
                  </select>
                </div>
                <div v-if="cht.type === 'monthly'" class="form-group col-2">
                  <label for="module">From Month</label>
                  <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="cht.fromMonth">
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </div>
                <div v-if="cht.type === 'monthly'" class="form-group col-2">
                  <label for="module">To Month</label>
                  <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="cht.toMonth">
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </div>
                <div v-if="cht.type === 'monthly'" class="form-group col-2">
                  <label for="module">Year</label>
                  <select type = "dropdown" class="form-control" id="action" v-model="cht.year">
                    <option v-for="year in years" v-bind:key="year" :value="year">{{ year }}</option>
                  </select>
                </div>
                <div v-if="cht.type === 'weekly'" class="form-group col-3">
                  <label for="module">From Week</label>
                  <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="cht.fromWeek">
                    <option v-for="(list, index) in this.cht.week" :key="index" :value="list.value">{{ list.title }}</option>
                  </select>
                </div>
                <div v-if="cht.type === 'weekly'" class="form-group col-3">
                  <label for="module">To Week</label>
                  <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="cht.toWeek">
                    <option v-for="(list, index) in this.cht.week" :key="index" :value="list.value">{{ list.title }}</option>
                  </select>
                </div>
                <div v-if="cht.type === 'weekly'" class="form-group col-2">
                  <label for="module">Year</label>
                  <select type = "dropdown" class="form-control" id="action" v-model="cht.year" @change="yearChanged()">
                    <option v-for="year in years" v-bind:key="year" :value="year">{{ year }}</option>
                  </select>
                </div>
                <div class="form-group col-1">
                  <button type="button" style="margin-top: 32px;" @click="filter" class="btn btn-outline-success">Filter</button>
                </div>
              </div>

              <div class="row" v-if="cht.type === 'monthly'">
                <div class="form-group col-6">
                  <app-chart v-if="chartLoaded" :isMixed="true" :isStacked="false" :type="barChart" :dataset="submissionPerDepartment.data" :labels="submissionPerDepartment.label" :title="submissionPerDepartment.title"></app-chart>
                </div>
                <div class="form-group col-6">
                  <app-chart v-if="chartLoaded" :isMixed="true" :isStacked="false" :type="barChart" :dataset="submissionPerMonth.data" :labels="submissionPerMonth.label" :title="submissionPerMonth.title"></app-chart>
                </div>
              </div>

              <div class="row" v-if="cht.type === 'monthly'">
                <div class="form-group col-6">
                  <div id="table-caption">{{this.submissionPerDepartmentTableTitle}}</div>
                  <app-datatable :type="'view'" :elements="dtElementsSubmissionTable" :collections="this.submissionPerDepartmentTable" v-on:selectedRow="selectRow"></app-datatable>
                </div>
                <div class="form-group col-6">
                  <app-chart v-if="chartLoaded" :isMixed="false" :isStacked="true" :type="barChart" :dataset="submissionPerStatus.data" :labels="submissionPerStatus.label" :title="submissionPerStatus.title"></app-chart>
                </div>
              </div>

              <div class="row" v-if="cht.type === 'weekly'">
                <div class="form-group col-6">
                  <app-chart v-if="chartLoaded" :isMixed="true" :isStacked="false" :type="barChart" :dataset="submissionWeekly.data" :labels="submissionWeekly.label" :title="submissionWeekly.title"></app-chart>
                </div>
                <div class="form-group col-6">
                  <app-chart v-if="chartLoaded" :isMixed="false" :isStacked="true" :type="barChart" :dataset="submissionDepartmentWeekly.data" :labels="submissionDepartmentWeekly.label" :title="submissionDepartmentWeekly.title"></app-chart>
                </div>
              </div>

              <div class="row" v-if="cht.type === 'weekly'">
                <div class="form-group col-12">
                  <div id="table-caption">{{this.submissionTargetPerDepartmentTableTitle}}</div>
                  <app-datatable :type="'view'" :elements="dtElementsSubmissionTargetTable" :collections="this.submissionTargetPerDepartmentTable" v-on:selectedRow="selectRow"></app-datatable>
                </div>
              </div>

              <!-- <div class="row">
                <div class="form-group col-4">
                  <app-chart v-if="chartLoaded" :type="pieChart" :data="dataPerCategory" :labels="labelPerCategory" :title="titlePerCategory"></app-chart>
                </div>
                <div class="form-group col-4">
                  <app-chart v-if="chartLoaded" :type="pieChart" :data="dataPerStatus" :labels="labelPerStatus" :title="titlePerStatus"></app-chart>
                </div>
                <div class="form-group col-4">
                  <app-chart v-if="chartLoaded" :type="pieChart" :data="dataPerDepartmentSubmitted" :labels="labelPerDepartmentSubmitted" :title="titlePerDepartmentSubmitted"></app-chart>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-4">
                  <app-chart v-if="chartLoaded" :type="pieChart" :data="dataPerDepartmentReported" :labels="labelPerDepartmentReported" :title="titlePerDepartmentReported"></app-chart>
                </div>
                <div class="form-group col-8">
                  <app-chart style="height: 250px" :type="lineChart" v-if="chartLoaded" :data="dataQBOFiltered" :labels="labelQBOFiltered" :title="titleQBOFiltered" :yAxis="yAxisLabelQBOFiltered" :xAxis="xAxisLabelQBOFiltered"></app-chart>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-6">
                  <div id="table-caption">QBO Open</div>
                  <app-datatable :type="'view'" :elements="dtQboOpenData" :collections="qboOpenData" v-on:selectedRow="selectRow"></app-datatable>
                </div>
                <div class="form-group col-6">
                  <div id="table-caption">QBO Closed</div>
                  <app-datatable :type="'view'" :elements="dtQboClosedData" :collections="qboClosedData" v-on:selectedRow="selectRow"></app-datatable>
                </div>
              </div>
              <br /><br />
              <div class="row">
                <div class="form-group col-6">
                  <div id="table-caption">QBO Feedback</div>
                  <app-datatable :type="'view'" :elements="dtQboFeedbackData" :collections="qboFeedbackData" v-on:selectedRow="selectRow"></app-datatable>
                </div>
                <div class="form-group col-6">
                  <div id="table-caption">QBO Invalid</div>
                  <app-datatable :type="'view'" :elements="dtQboInvalidData" :collections="qboInvalidData" v-on:selectedRow="selectRow"></app-datatable>
                </div>
              </div> -->

            </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import AppChart from '../components/AppChart.vue'
import AppDatatable from '../components/AppDatatable.vue'
import api from '../services/api'
import moment from 'moment'
import { chart } from '../models/chart'
import { prettifyErrorMessage } from '../utils'

export default {
  components: {
    AppChart, AppDatatable
  },
  data() {
    return {
      cht: {...chart},

      listErr: [],

      pieChart: 'pie',
      lineChart: 'line',
      barChart: 'bar',
      mixedChart: 'mixed',
      chartLoaded: false,
      selectedId: '',

      submissionPerDepartment: {},
      submissionPerMonth: {},

      submissionPerDepartmentTable: {},
      submissionPerDepartmentTableTitle: '',
      dtElementsSubmissionTable: [],

      submissionPerStatus: {},

      submissionWeekly: {},
      submissionDepartmentWeekly: {},

      submissionTargetPerDepartmentTable: {},
      submissionTargetPerDepartmentTableTitle: '',
      dtElementsSubmissionTargetTable: [],

      // dataPerCategory: [],
      // labelPerCategory: [],
      // titlePerCategory: 'QBO Per Category',

      // dataPerStatus: [],
      // labelPerStatus: [],
      // titlePerStatus: 'QBO Status',

      // dataPerDepartmentSubmitted: [],
      // labelPerDepartmentSubmitted: [],
      // titlePerDepartmentSubmitted: 'QBO Submitted per Department',

      // dataPerDepartmentReported: [],
      // labelPerDepartmentReported: [],
      // titlePerDepartmentReported: 'QBO Reported per Department',

      // dataQBOFiltered: [],
      // labelQBOFiltered: [],
      // titleQBOFiltered: 'Number QBO Per Month', 
      // yAxisLabelQBOFiltered: 'Value',
      // xAxisLabelQBOFiltered: 'Month',

      // qboOpenData: '',
      // dtQboOpenData: [
      //   {
      //     title: 'QBO No.',
      //     column: 'qboNo',
      //     type: 'text'
      //   },
      //   {
      //     title: 'Area Observation',
      //     column: 'areaObservation',
      //     type: 'text'
      //   },
      //   {
      //     title: 'Description',
      //     column: 'description',
      //     type: 'text'
      //   },
      //   {
      //     title: 'PIC',
      //     column: 'PIC',
      //     type: 'text'
      //   }
      // ],

      // qboFeedbackData: '',
      // dtQboFeedbackData: [
      //   {
      //     title: 'QBO No.',
      //     column: 'qboNo',
      //     type: 'text'
      //   },
      //   {
      //     title: 'Area Observation',
      //     column: 'areaObservation',
      //     type: 'text'
      //   },
      //   {
      //     title: 'Description',
      //     column: 'description',
      //     type: 'text'
      //   }
      // ],

      // qboClosedData: '',
      // dtQboClosedData: [
      //   {
      //     title: 'QBO No.',
      //     column: 'qboNo',
      //     type: 'text'
      //   },
      //   {
      //     title: 'Area Observation',
      //     column: 'areaObservation',
      //     type: 'text'
      //   },
      //   {
      //     title: 'Description',
      //     column: 'description',
      //     type: 'text'
      //   },
      //   {
      //     title: 'Rootcause',
      //     column: 'sootCause',
      //     type: 'text'
      //   }
      // ],

      // qboInvalidData: '',
      // dtQboInvalidData: [
      //   {
      //     title: 'QBO No.',
      //     column: 'qboNo',
      //     type: 'text'
      //   },
      //   {
      //     title: 'Area Observation',
      //     column: 'areaObservation',
      //     type: 'text'
      //   },
      //   {
      //     title: 'Description',
      //     column: 'description',
      //     type: 'text'
      //   },
      //   {
      //     title: 'Rootcause',
      //     column: 'sootCause',
      //     type: 'text'
      //   }
      // ],
    }
  },
  async created() {
    this.init()
  },
  computed : {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2017}, (value, index) => 2018 + index)
    }
  },
  methods: {
    async init() {
      this.cht.type = 'monthly'
      this.cht.fromMonth = 1
      this.cht.toMonth = moment().format('M')
      this.cht.year = moment().format('YYYY')

      this.filter();

      // const categoryApi = api('dashboard/category')
      // const categoryData = await categoryApi.get() 
      // this.dataPerCategory = categoryData[0]
      // this.labelPerCategory = categoryData[1]

      // const statusApi = api('dashboard/status')
      // const statusData = await statusApi.get() 
      // this.dataPerStatus = statusData[0]
      // this.labelPerStatus = statusData[1]
      // // this.dataPerStatusTable = statusData[2]

      // const dsApi = api('dashboard/department-submitted')
      // const dsData = await dsApi.get() 
      // this.dataPerDepartmentSubmitted = dsData[0]
      // this.labelPerDepartmentSubmitted = dsData[1]
      // // this.dataPerDepartmentSubmittedTable = dsData[2]

      // const drApi = api('dashboard/department-reported')
      // const drData = await drApi.get() 
      // this.dataPerDepartmentReported = drData[0]
      // this.labelPerDepartmentReported = drData[1]
      // // this.dataPerDepartmentReportedTable = drData[2]

      // const qboApi = api('dashboard/qbo-filtered')
      // const qboData = await qboApi.get() 
      // this.dataQBOFiltered = qboData[0]
      // this.labelQBOFiltered = qboData[1]
      // // this.dataQBOFilteredTable = qboData[2]

      // const qboOpenApi = api('dashboard/qbo-open')
      // this.qboOpenData = await qboOpenApi.get()

      // const qboFeedbackApi = api('dashboard/qbo-feedback')
      // this.qboFeedbackData = await qboFeedbackApi.get()

      // const qboClosedApi = api('dashboard/qbo-closed')
      // this.qboClosedData = await qboClosedApi.get()

      // const qboInvalidApi = api('dashboard/qbo-invalid')
      // this.qboInvalidData = await qboInvalidApi.get()

      // this.chartLoaded = true
    },
    async filter() {
      this.validate()

      if(this.listErr.length > 0) {
        this.showValidationError()
        return
      }

      this.chartLoaded = false

      let query = {}
      if(this.cht.type === 'monthly') {
        query = {
          params: {
            fromMonth: this.cht.fromMonth,
            toMonth: this.cht.toMonth,
            year: this.cht.year,
            type: this.cht.type
          }
        }
      } else if (this.cht.type === 'weekly') {
        query = {
          params: {
            fromWeek: this.cht.fromWeek,
            toWeek: this.cht.toWeek,
            year: this.cht.year,
            type: this.cht.type,
          }
        }
      }
      // const query = {
      //   params: {
      //     fromMonth: this.cht.fromMonth,
      //     toMonth: this.cht.toMonth,
      //     year: this.cht.year,
      //     // week: this.cht.week,
      //     type: this.cht.type
      //   }
      // }

      console.log('jana-query : ' + JSON.stringify(query))

      //#region yearly
      if(this.cht.type === 'monthly') {
        console.log(this.cht.type + ' - ' + this.cht.fromMonth + ' - ' + this.cht.toMonth + ' - ' + this.cht.year)

        const submissionApi = api('dashboard/submission-per-department')
        const submissionData = await submissionApi.getWithQuery(query)
        // console.log(submissionData)
        this.submissionPerDepartment = submissionData

        const submissionMonthApi = api('dashboard/submission-per-month')
        const submissionMonthData = await submissionMonthApi.getWithQuery(query)
        // console.log(submissionMonthData)
        this.submissionPerMonth = submissionMonthData

        const submissionTableApi = api('dashboard/submission-per-department-table')
        const submissionTableData = await submissionTableApi.getWithQuery(query)
        // console.log(submissionTableData)
        this.submissionPerDepartmentTable = submissionTableData.data
        this.submissionPerDepartmentTableTitle = submissionTableData.title
        this.dtElementsSubmissionTable = submissionTableData.dtElement
        // console.log(submissionTableData.dtElement)

        const submissionStatusApi = api('dashboard/submission-per-status')
        const submissionStatusData = await submissionStatusApi.getWithQuery(query)
        // console.log(submissionStatusData)
        this.submissionPerStatus = submissionStatusData
        // console.log(this.submissionPerStatus.data);
      }
      //#endregion

      //#region weekly
      if(this.cht.type === 'weekly') {
        console.log(this.cht.type + ' - ' + this.cht.fromWeek + ' - ' + this.cht.fromWeek + ' - ' + this.cht.year)

        const submissionApiWeekly = api('dashboard/submission-per-department-weekly')
        const submissionDataWeekly = await submissionApiWeekly.getWithQuery(query)
        console.log('jana-submissionDataWeekly : ' + JSON.stringify(submissionDataWeekly))
        this.submissionWeekly = submissionDataWeekly

        const submissionDepartmentApiWeekly = api('dashboard/submission-total-department-weekly')
        const submissionDepartmentDataWeekly = await submissionDepartmentApiWeekly.getWithQuery(query)
        console.log('jana-submissionDepartmentDataWeekly : ' + JSON.stringify(submissionDepartmentDataWeekly))
        this.submissionDepartmentWeekly = submissionDepartmentDataWeekly

        const submissionTargetTableApi = api('dashboard/submission-target-per-department-weekly')
        const submissionTargetTableData = await submissionTargetTableApi.getWithQuery(query)
        console.log(submissionTargetTableData)
        this.submissionTargetPerDepartmentTable = submissionTargetTableData.data
        this.submissionTargetPerDepartmentTableTitle = submissionTargetTableData.title
        this.dtElementsSubmissionTargetTable = submissionTargetTableData.dtElement
        // console.log(submissionTableData.dtElement)
      }
      //#endregion
      


      // this.submissionPerDepartmentTableTitle = submissionTableData.title
      // this.dtElementsSubmissionTable = submissionTableData.dtElement
      // console.log(submissionTableData.dtElement)
      
      //calculate week from selected year
      // var weeks = [];
      // var startDate = moment(new Date(2023,0,1)).isoWeekday(8);
      // console.log('jana-startdate - ' + startDate)
      // if(startDate.date() === 8) {
      //   startDate = startDate.isoWeekday(-6)
      // }
      // var today = moment().isoWeekday('Sunday');
      // while(startDate.isBefore(today)) {
      //   let startDateWeek = startDate.isoWeekday('Monday').format('DD-MM-YYYY');
      //   let endDateWeek = startDate.isoWeekday('Sunday').format('DD-MM-YYYY');
      //   startDate.add(7,'days');
      //   weeks.push([startDateWeek,endDateWeek]);
      // }
      // console.log(weeks)

      this.refreshWeek();

      this.chartLoaded = true
    },
    async yearChanged() {
      // console.log('TEST YEAR CHANGED');
      this.cht.fromWeek = '';
      this.cht.toWeek = '';
      this.refreshWeek();
    },
    getDateOfFirstDayOfFirstWeek(year) {
      const date = new Date(year, 0, 1)
      if ((date.getDay() + 6) % 7 === 0) return date
      if ((date.getDay() + 6) % 7 < 4) {
        date.setDate(date.getDate() - (date.getDay() + 6) % 7)
        return date
      } else {
        date.setDate(8 - (date.getDay() + 6) % 7)
        return date
      }
    },
    async refreshWeek() {
      console.log('new week format 2022 : ', this.getDateOfFirstDayOfFirstWeek(2022));
      console.log('new week format 2023 : ', this.getDateOfFirstDayOfFirstWeek(2023));
      console.log('new week format 2024 : ', this.getDateOfFirstDayOfFirstWeek(2024));
      console.log('new week format 2025 : ', this.getDateOfFirstDayOfFirstWeek(2025));

      // let beginningOfYear = this.cht.year + '-01-01'
      // // console.log('beginningOfYear : ' + beginningOfYear)
      let endOfYear = (moment().year() == this.cht.year) ? new Date() : this.cht.year + '-12-31' ;
      // // console.log('endingOfYear : ' + endOfYear)
      // let startDate = moment(beginningOfYear).startOf('week').format('YYYY-MM-DD');
      // // console.log('startDate : ' + startDate)
      // // console.log(moment.locale());
      // let endDate = moment(endOfYear).startOf('week').format('YYYY-MM-DD');
      // // console.log('endDate : ' + endDate)

      let startDate = moment(this.getDateOfFirstDayOfFirstWeek(this.cht.year)).format('YYYY-MM-DD');
      console.log('startDate : ' + startDate)
      let endDate = moment(endOfYear).startOf('week').format('YYYY-MM-DD');

      let weeks = [];
      let index = 1;
      while (startDate <= endDate) {
        let daysInWeeks = {};
        if (index > 0) {
          daysInWeeks.title = 'Week ' + index + '(' + startDate + ' - ' + moment(startDate).add(6, 'days').format('YYYY-MM-DD') + ')';
          // daysInWeeks.value = startDate + '-' + moment(startDate).add(6, 'days').format('YYYY-MM-DD');
          daysInWeeks.value = index + ',' + startDate;
          weeks.push(daysInWeeks);
          // console.log('daysInWeeks : ' + daysInWeeks);
        }
        
        startDate = moment(startDate).add(7, 'days').format('YYYY-MM-DD');
        if(index == 0) {
          this.cht.firstDateOfWeek = startDate;
        }
        index += 1;
      }

      // console.log('weeks:', weeks);

      this.cht.week = weeks;
      this.listOfWeeks = [];
      this.listOfWeeks = weeks;
    },
    selectRow(id) {
      this.selectedId = id
    },
    validate() {
      this.listErr = []
      //validation
      //3. check if Week is selected when click Filter
      if(this.cht.type === 'weekly' && 
          (this.cht.fromWeek === '' ||this.cht.toWeek === ''
          || this.cht.fromWeek === undefined || this.cht.fromWeek === undefined)) 
        {
        this.listErr.splice(this.listErr.length, 0, 'Please select week!')
      } else {
        //1. check if ToMonth is larger from FromMonth
        if (this.cht.type === 'monthly' && (Number(this.cht.fromMonth) > Number(this.cht.toMonth))) {
          this.listErr.splice(this.listErr.length, 0, 'Please select correct month format!')
        }
        //2. check if toWeek is larger from FromWeek
        if (this.cht.type === 'weekly' && (Number(this.cht.fromWeek) > Number(this.cht.toWeek))) {
          this.listErr.splice(this.listErr.length, 0, 'Please select correct week format!')
        }
      }
    },
    showValidationError() {
      Vue.notify({
        group: 'appNotif',
        title: 'Validation errors',
        text: prettifyErrorMessage(this.listErr),
        type: 'error'
      })
    },
  }
}
</script>